import { Button } from './ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
import { Reveal } from './motion/Reveal';

const MotionButton = motion(Button);

export const CTABanner = () => {
  const scrollToContact = () => {
    const element = document.querySelector('#contato');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      data-testid="cta-banner-section"
      className="py-20 bg-slate-900 relative overflow-hidden"
    >
      {/* Grid Pattern */}
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: `linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)`,
          backgroundSize: '40px 40px'
        }}
      />

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-900/50 via-transparent to-blue-600/30" />

      {/* Glow Effects */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] bg-blue-500/20 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-yellow-500/10 rounded-full blur-3xl" />

      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Emoji/Icon */}
        <Reveal delay={0.1} className="mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-yellow-400 to-orange-400 rounded-2xl shadow-lg shadow-yellow-500/30 rotate-3">
            <Sparkles className="w-8 h-8 text-white" />
          </div>
        </Reveal>

        {/* Title */}
        <Reveal
          as="h2"
          delay={0.2}
          data-testid="cta-banner-title"
          className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-6"
        >
          Comece a fazer justiça com
          <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 to-yellow-400">
            praticidade e segurança
          </span>
        </Reveal>

        {/* Subtitle */}
        <Reveal
          as="p"
          delay={0.3}
          className="text-lg md:text-xl text-blue-100/80 leading-relaxed mb-10 max-w-2xl mx-auto"
        >
          Nunca foi tão simples buscar o que já é seu. Receba uma
          indenização justa pelos seus direitos e só pague quando ganhar.
        </Reveal>

        {/* CTA Button */}
        <Reveal delay={0.4}>
          <MotionButton
            data-testid="cta-banner-button"
            onClick={scrollToContact}
            size="lg"
            whileHover={{ y: -2 }}
            whileTap={{ scale: 0.97 }}
            className="bg-yellow-400 hover:bg-yellow-300 text-blue-900 rounded-full px-10 py-6 h-auto text-lg font-bold shadow-[0_8px_30px_rgba(250,204,21,0.3)] hover:shadow-[0_20px_40px_-15px_rgba(250,204,21,0.6)] transition-[background-color,box-shadow] duration-500 ease-[cubic-bezier(0.23,1,0.32,1)] group"
          >
            Verifique GRÁTIS
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </MotionButton>
        </Reveal>
      </div>
    </section>
  );
};
